import { ReactElement, useRef } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

import { changePaymentDueDateModalContainerId } from 'const/modalContainerId'
import i18n from 'strings/i18n'
import {
  ModalHeader,
  SlideInModalPortal
} from 'syf-component-library/ui/patterns/SlideInModalPortal'

import { ChangePaymentDueDate } from 'account-services-mfe'
import getMFEConfig from 'helpers/getMFEConfig'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'

const ChangePaymentDueDateModal = (): ReactElement => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const headerRef = useRef(null)

  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')

  const handleCloseModal = () => {
    updateModalStatus('')
  }

  const handleEscapeAndModalHeader = () => {
    triggerAnalyticsEvent({
      pageFunction: 'account services',
      pageKind: 'account services'
    })
    handleCloseModal()
  }

  return (
    <SlideInModalPortal
      containerId={changePaymentDueDateModalContainerId(selectedAccount)}
      escapeModalHandler={handleEscapeAndModalHeader}
      id={`cpdd-slide-in-modal-${selectedAccount}`}
      isOpen={modalId === 'ChangePaymentDueDate'}
      modalTriggerId={modalTriggerId}
      header={
        <ModalHeader
          closeModal={handleEscapeAndModalHeader}
          content={i18n({ modal: 'changeDueDateTitle' }) as string}
          data-test="cpdd-modal-header"
          dataType="x button"
          headerRef={headerRef}
        />
      }
    >
      <ChangePaymentDueDate
        config={mfeConfig}
        handleClose={handleCloseModal}
        selectedAccountId={selectedAccount}
      />
    </SlideInModalPortal>
  )
}

export default ChangePaymentDueDateModal
